// extracted by css-extract-rspack-plugin
export default {"partialRefundBanner":"partialRefundBanner-iVYsLy"};